import { appendEnvVars } from '@cli-utils/files.js'

export function persistDatabaseUrl(cwd: string, databaseUrl: string): void {
  appendEnvVars(
    cwd,
    [
      {
        header: 'Database (PostgreSQL)',
        vars: [{ key: 'DATABASE_URL', value: databaseUrl }]
      }
    ],
    new Set(['DATABASE_URL'])
  )
}
